import {
  AuthAccountContactTypeChoices,
  BuildingIcon,
  ContactType,
  FlagIcon,
  Loading,
  Typography,
  useFetchFile,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { AuthAccountProfileEmploymentStatusChoices, useGetJobSeekerByIdQuery } from "@graphql/generated";
import { Card } from "@heroui/react";
import { formatString } from "@utils/formatString";
import { useParams } from "react-router-dom";

const JobSeekerGeneralInfo = () => {
  const params = useParams();

  const { data, loading: jobSeekerLoading } = useGetJobSeekerByIdQuery({
    variables: {
      id: params.id ?? "",
    },
  });
  const jobSeeker = data?.admin?.jobSeekers?.edges[0]?.node;
  const avatar = jobSeeker?.profile?.avatar?.file;
  const name = jobSeeker?.firstName + " " + jobSeeker?.lastName;
  const email = jobSeeker?.email;
  const country = jobSeeker?.profile?.city?.country?.name;
  const city = jobSeeker?.profile?.city?.name;
  const field = jobSeeker?.workexperiences?.[0]?.jobTitle;
  const contacts = jobSeeker?.profile?.contacts;
  const phone = contacts?.find((c: ContactType | null) => c?.type === AuthAccountContactTypeChoices.PHONE)?.value;
  const cooperationTerms = jobSeeker?.profile?.jobLocationType;
  const latestStatus = jobSeeker?.profile?.employmentStatus;
  const lastJobExperience = jobSeeker?.workexperiences?.[0];
  const company = lastJobExperience?.organization;
  const { data: avatarBlob } = useFetchFile({ urlPath: avatar, userType: UserTypeEnum.ADMIN });

  return (
    <Card className="p-4 flex flex-row justify-between items-center w-full gap-6">
      {jobSeekerLoading ? (
        <Loading />
      ) : (
        <>
          <div className="flex items-center gap-4 min-w-[260px]">
            {avatarBlob ? (
              <img src={avatarBlob} alt="avatar" width={75} height={75} className="rounded-md object-cover" />
            ) : (
              <div className="w-16 h-16 rounded-md bg-gray-300 flex items-center justify-center"></div>
            )}
            <div className="flex flex-col justify-between gap-1">
              <Typography className="text-lg font-semibold">{name}</Typography>
              <Typography className="text-xs text-gray-400">{email}</Typography>
              <Typography className="text-xs text-gray-400">{phone}</Typography>
            </div>
          </div>
          <div className="flex flex-col gap-4 min-w-[220px]">
            {(city || country) && (
              <div className="flex items-center gap-2">
                <FlagIcon className="w-5 h-5 lg:w-6 lg:h-6" />
                <Typography className="text-xs lg:text-sm">{`${city ?? "City"} , ${country ?? "Country"}`}</Typography>
              </div>
            )}
            {field && (
              <div className="flex items-center gap-2">
                <BuildingIcon className="w-5 h-5 lg:w-6 lg:h-6" />
                <Typography className="text-xs lg:text-sm">
                  {field} in {company}
                </Typography>
              </div>
            )}
          </div>
          <div className="flex flex-col gap-2 items-start min-w-[480px] border-l border-gray-200 pl-4">
            <div>
              <Typography className="text-xs text-gray-500 mb-1">Cooperation terms:</Typography>
              <div className="flex gap-2">
                {cooperationTerms?.map((term) => (
                  <span
                    key={term}
                    className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded border border-gray-200"
                  >
                    {formatString(term ?? "")}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <Typography className="text-xs text-gray-500">Latest status :</Typography>
              {latestStatus === AuthAccountProfileEmploymentStatusChoices.EMPLOYED ? (
                <span className="flex items-center gap-1 bg-green-50 text-green-600 text-xs px-2 py-0.5 rounded border border-green-200">
                  {formatString(latestStatus ?? "")}
                </span>
              ) : (
                <span className="flex items-center gap-2 bg-red-50 text-red-600 text-xs px-2 py-0.5 rounded border border-red-200">
                  {formatString(latestStatus ?? "")}
                </span>
              )}
            </div>
          </div>
        </>
      )}
    </Card>
  );
};

export default JobSeekerGeneralInfo;
